<template>
    <div hidden>
        <div ref="mychildcomponent" id='purchaseInvoice' style="width:400px;z-index:-9999">
            <!--INFORMATION-->
            <div style="width:400px;margin-left:20px;">

                <div style="text-align: center;margin-bottom:15px;" v-if="b2b && b2c">
                    <div v-if="list.customerCategory=='B2B – Business to Business'">
                        <span style="font-size:24px;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Invoice Type (Eng)'))">{{taxInvoiceLabel}}<br /></span>
                        <span style="font-size:24px;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Invoice Type (Ar)'))">{{taxInvoiceLabelAr}}<br /></span>
                    </div>
                    <div v-else-if="list.customerCategory=='B2C – Business to Client'">
                        <span style="font-size:24px;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Invoice Type (Eng)'))">{{simplifyTaxInvoiceLabel}}<br /></span>
                        <span style="font-size:24px;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Invoice Type (Ar)'))">{{simplifyTaxInvoiceLabelAr}}<br /></span>
                    </div>
                    <div v-else>
                        <span style="font-size:24px;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Invoice Type (Eng)'))">{{simplifyTaxInvoiceLabel}}<br /></span>
                        <span style="font-size:24px;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Invoice Type (Ar)'))">{{simplifyTaxInvoiceLabelAr}}<br /></span>
                    </div>
                </div>

                <div style="text-align: center;margin-bottom:15px;" v-else-if="b2b">
                    <span style="font-size:24px;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Invoice Type (Ar)'))">{{taxInvoiceLabelAr}}<br /></span>
                    <span style="font-size:24px;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Invoice Type (Eng)'))">{{taxInvoiceLabel}}<br /></span>
                </div>

                <div style="text-align: center;margin-bottom:15px;" v-else-if="b2c">
                    <span style="font-size:24px;color:black;"  v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Invoice Type (Ar)'))">{{simplifyTaxInvoiceLabelAr}}<br /></span>
                    <span style="font-size:24px;color:black;"  v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Invoice Type (Eng)'))">{{simplifyTaxInvoiceLabel}}<br /></span>
                </div>


                <div style="width:100%;text-align:center;margin-top:10px" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Print Logo'))">
                    <img :src="headerFooters.company.logoPath" style="width: auto; max-width: 150px; height: auto; max-height: 120px;">
                </div>

                <div style="text-align: center;margin-bottom:15px;">
                    <div style="text-align: center;">
                        <span style="font-size:30px;font-weight:bold;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Business Name (Ar)'))">{{headerFooters.company.nameArabic}}<br /></span>
                        <span style="font-size:30px;font-weight:bold;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Business Name (Eng)'))">{{headerFooters.company.nameEnglish}}<br /></span>
                        <span style="font-size:18px;font-weight:bold;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Business Type (Ar)')) && headerFooters.company.categoryArabic!='null'">{{headerFooters.company.categoryArabic}}<br /></span>
                        <span style="font-size:18px;font-weight:bold;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Business Type (Eng)')) && headerFooters.company.categoryEnglish!='null'">{{headerFooters.company.categoryEnglish}}<br /></span>
                        <span style="font-size:18px;font-weight:bold;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Welcome/Tagline (Ar)')) && headerFooters.welcomeLineAr!='' && headerFooters.welcomeLineAr!=null">{{headerFooters.welcomeLineAr}}<br /></span>
                        <span style="font-size:18px;font-weight:bold;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Welcome/Tagline (Eng)')) && headerFooters.welcomeLineEn!='' && headerFooters.welcomeLineEn!=null">{{headerFooters.welcomeLineEn}}<br /></span>

                        <span v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Management No (Eng)')) || PrintOption(headerFooters.printOptions.find(x => x.label=='Management No (Ar)'))" style="font-size:15px;color:black;"><span v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Management No (Eng)'))">Management No: </span> {{headerFooters.managementNo}}<span v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Management No (Ar)'))"> :رقم الإدارة</span> <br /></span>
                        <span v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Store Contact No (Eng)')) || PrintOption(headerFooters.printOptions.find(x => x.label=='Store Contact No (Ar)'))" style="font-size:15px;color:black;"><span v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Store Contact No (Eng)'))">Store Contact Number: </span> {{headerFooters.contactNo}}<span v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Store Contact No (Ar)'))"> :الـرقم الإدارة / المحل</span> <br /></span>

                        <p style="border:1px solid; width:350px;color:black;margin-left:auto;margin-right:auto;margin-top:0.3rem;margin-bottom:0.3rem;">
                            <span style="font-weight: bold;"><span style="font-weight: bold;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='VAT / Tax ID (Eng)'))">VAT No :</span> {{headerFooters.company.vatRegistrationNo}}<span style="font-weight: bold;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='VAT / Tax ID (Ar)'))"> :الرقم الضريبي</span>    <br /></span>
                            <span style="font-weight: bold;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='CR Number (Eng)')) || PrintOption(headerFooters.printOptions.find(x => x.label=='CR Number (Ar)'))"><span style="font-weight: bold;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='CR Number (Eng)'))">CR Number  :</span> {{headerFooters.company.companyRegNo}}<span style="font-weight: bold;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='CR Number (Ar)'))"> :الرقـم السـجـل الـتـجـارى </span>    <br /></span>
                            <span style="font-size:18px;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Company Name (Ar)'))">{{headerFooters.company.companyNameArabic}}<br /></span>
                            <span style="font-size:18px;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Company Name (Eng)'))">{{headerFooters.company.companyNameEnglish}}<br /></span>

                            <span style="font-size:16px;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Company Address (Ar)'))">{{headerFooters.company.addressArabic}}<br /></span>
                            <span style="font-size:16px;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Company Address (Eng)'))">{{headerFooters.company.addressEnglish}}<br /></span>
                        </p>

                        <p style="font-size:16px;color:black;" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Business Address (Arabic)')) || PrintOption(headerFooters.printOptions.find(x => x.label=='Business Address (English)'))">
                            <span v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Business Address (Arabic)'))">{{headerFooters.businessAddressArabic}}</span> <br />
                            <span v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Business Address (English)'))">{{headerFooters.businessAddressEnglish}}</span>
                        </p>
                    </div>
                </div>

                <div style="width:100%;">                   
                    <div style="text-align: center;">
                        <p v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Invoice Number(Eng)')) && PrintOption(headerFooters.printOptions.find(x => x.label=='Invoice Number(Ar)'))" style="font-size: 15px; font-weight: bold;color:black;margin-bottom:2px;padding-bottom:2px;"><span> Invoice No.</span> <span style="border:4px solid;font-size:25px;font-weight:bold;padding-left:2px;padding-right:2px;color:black;text-align:center"> {{list.registrationNo}}</span> <span style="font-size: 15px; font-weight: bold;color:black;margin-bottom:2px;padding-bottom:2px;text-align:right">رقم الفاتورة</span></p>

                        <p v-else-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Invoice Number(Eng)'))" style="border: 1px solid; font-size: 15px; font-weight: bold; color: black; margin-bottom: 2px; padding-bottom: 2px; text-align: center;width: 350px;margin-left: auto;margin-right: auto;"><span> Invoice No : <span style="font-size: 18px;">{{list.registrationNo}}</span></span>  </p>
                        <p v-else-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Invoice Number(Ar)'))" style="border: 1px solid; font-size: 15px; font-weight: bold; color: black; margin-bottom: 2px; padding-bottom: 2px; text-align: center;width: 350px;margin-left: auto;margin-right: auto;"><span> <span style="font-size: 18px;">{{list.registrationNo}} :</span>رقم الفاتورة</span>  </p>
                        <p v-else style="font-size: 15px; font-weight: bold;color:black;margin-bottom:2px;padding-bottom:2px;"><span> Invoice No.</span> <span style="border:4px solid;font-size:25px;font-weight:bold;padding-left:2px;padding-right:2px;color:black;text-align:center"> {{list.registrationNo}}</span> <span style="font-size: 15px; font-weight: bold;color:black;margin-bottom:2px;padding-bottom:2px;text-align:right">رقم الفاتورة</span></p>

                    </div>

                    <table class="table table-borderless " style="width:400px;">
                        <!--<tr style="font-size:16px;">
                            <td class="" style="border-top: 0;padding-left:1px;padding-right:1px;color:black;text-align:left;padding-bottom:0px !important">  حي الحرازات</td>
                            <td style="text-align:right; border-top: 0;padding-left:1px;padding-right:1px;color:black;padding-bottom:0px !important;font-weight:bold"> جدة</td>
                        </tr>-->
                        
                        <tr style="font-size:16px;">
                            <td class="" style="border-top: 0;padding-left:1px;padding-right:1px;color:black;text-align:left;padding-bottom:0px !important">{{getdate(list.date)}} </td>
                            <td style="text-align:right; border-top: 0;padding-left:1px;padding-right:1px;color:black;padding-bottom:0px !important;font-weight:bold">التاريخ</td>
                        </tr>
                        <tr style="font-size:16px;">
                            <td class="" style="border-top: 0;padding-left:1px;padding-right:1px;color:black;text-align:left;padding-bottom:0px !important" v-if="list.cashCustomer != null">CASH CUSTOMER </td>
                            <td class="" style="border-top: 0;padding-left:1px;padding-right:1px;color:black;text-align:left;padding-bottom:0px !important" v-else>CREDIT CUSTOMER </td>
                            <td style="text-align:right; border-top: 0;padding-left:1px;padding-right:1px;color:black;padding-bottom:0px !important;font-weight:bold">زیون</td>
                        </tr>
                        <tr style="font-size:16px;" v-if="list.cashCustomer != null">
                            <td class="" style="border-top: 0;padding-left:1px;padding-right:1px;color:black;text-align:left;padding-bottom:0px !important">{{list.cashCustomer}}</td>
                            <td style="text-align:right; border-top: 0;padding-left:1px;padding-right:1px;color:black;padding-bottom:0px !important;font-weight:bold">الصندوق</td>
                        </tr>
                        <tr style="font-size:16px;" v-else>
                            <td class="" style="border-top: 0;padding-left:1px;padding-right:1px;color:black;text-align:left;padding-bottom:0px !important">{{ ($i18n.locale == 'en' ||isLeftToRight()) ? (list.customerNameEn != '' && list.customerNameEn != null) ? list.customerNameEn : list.customerNameAr : (list.customerNameAr != '' && list.customerNameAr != null) ? list.customerNameAr : list.customerNameEn}}</td>
                            <td style="text-align:right; border-top: 0;padding-left:1px;padding-right:1px;color:black;padding-bottom:0px !important;font-weight:bold">الصندوق</td>
                        </tr>
                        
                        <tr style="font-size:16px;">
                            <td class="" style="border-top: 0;padding-left:1px;padding-right:1px;color:black;text-align:left;padding-bottom:0px !important">{{list.counterCode}}</td>
                            <td style="text-align:right; border-top: 0;padding-left:1px;padding-right:1px;color:black;padding-bottom:0px !important;font-weight:bold">رقم الكاونتر</td>
                        </tr>
                        <tr style="font-size:16px;">
                            <td class="" style="border-top: 0;padding-left:1px;padding-right:1px;color:black;text-align:left;padding-bottom:0px !important">{{list.userName}}</td>
                            <td style="text-align:right; border-top: 0;padding-left:1px;padding-right:1px;color:black;padding-bottom:0px !important;font-weight:bold">أسم المستخدم</td>
                        </tr>
                        <!--<tr style="font-size:16px;">
                <td class="" style="border-top: 0;padding-left:1px;padding-right:1px;color:black;text-align:left;padding-bottom:0px !important">{{headerFooters.company.vatRegistrationNo}}</td>
                <td style="text-align:right; border-top: 0;padding-left:1px;padding-right:1px;color:black;padding-bottom:0px !important;font-weight:bold">الرقم الضريبي</td>
            </tr>-->


                    </table>


                </div>


                <div style="width:100%;">
                    <table class="table report-tbl" style="width:400px;margin-top:15px">
                        <tr class="heading" style="font-size:15px;border-bottom:1px solid black;border-top:1px solid; color:black">
                            <th style="text-align: center; width: 20%; border-bottom: 1px solid #000000;border-top: 1px solid #000000; padding-left: 1px; padding-right: 1px; color: black;">الإجمالي </th>
                            <th style="text-align: center; width: 5%; border-bottom: 1px solid #000000;border-top: 1px solid #000000; padding-left: 1px; padding-right: 1px; color: black;">السعر</th>
                            <th style="text-align: center; width: 10%; border-bottom: 1px solid #000000;border-top: 1px solid #000000; padding-left: 1px; padding-right: 1px; color: black;">الكمية</th>
                            <th style="text-align: center; width: 50%; border-bottom: 1px solid #000000;border-top: 1px solid #000000; padding-left: 1px; padding-right: 1px; color: black;">الوصف</th>
                            <th style="text-align: center; width: 5%; border-bottom: 1px solid #000000;border-top: 1px solid #000000; padding-left: 1px; padding-right: 1px; color: black;">رقم </th>

                        </tr>
                        <template v-for="(item, index) in list.saleItems">
                            <tr style="font-size:15px;" v-bind:key="item.id">
                                <td style="text-align: center; border-top: 0; padding-top: 0; padding-left: 1px; padding-right: 1px; color: black;">{{(item.total).toFixed(3).slice(0,-1)}}</td>
                                <td style="text-align: center; border-top: 0; padding-top: 0; padding-left: 1px; padding-right: 1px; color: black;">{{item.unitPrice.toFixed(3).slice(0,-1)}}</td>
                                <td style="text-align: center; border-top: 0; padding-top: 0; padding-left: 1px; padding-right: 1px; color: black;">{{item.quantity }}</td>
                                <td style="text-align: center; border-top: 0; padding-top: 0; padding-left: 1px; padding-right: 1px; color: black; font-weight: 600;" v-if="headerFooters.invoicePrint=='English & Arabic'">{{item.arabicName}} &nbsp;{{item.productName }}</td>
                                <td style="text-align: center; border-top: 0; padding-top: 0; padding-left: 1px; padding-right: 1px; color: black; font-weight: 600;" v-else-if="headerFooters.invoicePrint=='English'">{{item.productName }}</td>
                                <td style="text-align: center; border-top: 0; padding-top: 0; padding-left: 1px; padding-right: 1px; color: black; font-weight: 600;" v-else-if="headerFooters.invoicePrint=='العربية'">{{item.arabicName}}</td>
                                <td style="text-align: center; border-top: 0; padding-top: 0; padding-left: 1px; padding-right: 1px; color: black; font-weight: 600;" v-else>{{item.arabicName}} &nbsp;{{item.productName }}</td>
                                <td style="text-align: center; border-top: 0; padding-top: 0; padding-left: 1px; padding-right: 1px; color: black;">{{index+1}}</td>
                            </tr>
                        </template>

                        <tr style="font-size:16px;border-top:1px solid #000000;border-color:black !important ">
                            <td colspan="1" style=" text-align:right; border: 0px !important; padding-bottom: 1px;  color: black;padding-top:0px !important">{{list.saleItems.filter(prod => prod.quantity>0).length}}</td>
                            <td colspan="5" style="text-align: right; border: 0px !important; padding-bottom: 1px;   color: black;padding-top:0px !important">Quantity | عدد العنف  </td>
                        </tr>

                        <tr style="font-size:16px;">
                            <td colspan="1" style=" text-align: right; border: 0px !important; padding-bottom: 1px;  color: black;padding-top:0px !important">{{calulateTotalExclVAT.toFixed(3).slice(0,-1)}}</td>
                            <td colspan="5" style="text-align: right; border: 0px !important; padding-bottom: 1px;   color: black;padding-top:0px !important"> Total VAT Exclusive | المجموع قبل الصربية</td>
                        </tr>

                        <tr style="font-size:16px;">
                            <td colspan="1" style=" text-align: right; border: 0px !important; padding-bottom: 1px;  color: black;padding-top:0px !important">{{ calulateDiscountAmount.toFixed(3).slice(0,-1) }}</td>
                            <td colspan="5" style="text-align: right; border: 0px !important; padding-bottom: 1px;   color: black;padding-top:0px !important">  Discount | قيمة الخصم</td>
                        </tr>

                        <tr style="font-size:16px;">
                            <td colspan="1" style=" text-align: right; border: 0px !important; padding-bottom: 1px;  color: black;padding-top:0px !important">{{ ((calulateTotalExclVAT - calulateTotalInclusiveVAT) - calulateDiscountAmount).toFixed(3).slice(0,-1) }}</td>
                            <td colspan="5" style="text-align: right; border: 0px !important; padding-bottom: 1px;   color: black;padding-top:0px !important"> Total After Discount |الإجمالي بعد الخصم</td>
                        </tr>

                        <tr style="font-size:16px;">
                            <td colspan="1" style=" text-align: right; border: 0px !important; padding-bottom: 1px;  color: black;padding-top:0px !important">{{ calulateTotalVAT.toFixed(3).slice(0,-1) }}</td>
                            <td colspan="5" style="text-align: right; border: 0px !important; padding-bottom: 1px;   color: black;padding-top:0px !important"> VAT (15%)  | ضريبة القيمة المضافة</td>
                        </tr>

                        <tr style="font-size:16px;">
                            <td colspan="1" style=" text-align: right; border: 0px !important; padding-bottom: 1px;  color: black;padding-top:0px !important;font-weight:bold">{{ (calulateNetTotal - calulateDiscountAmount).toFixed(3).slice(0,-1) }}</td>
                            <td colspan="5" style="text-align: right; border: 0px !important; padding-bottom: 1px;   color: black;padding-top:0px !important;font-weight:bold"> Net Total |  المجموع شامل الضريبة </td>
                        </tr>
                    </table>

                    <div style="width:400px;border-top:1px solid #000000;border-color:black !important">
                        <p v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Gratitude Message (Ar)'))" style="text-align:center;color:black;"> <span style="margin-right:5px;color:black;">*</span> <span style="margin-right:10px;color:black;">*</span> <span style="font-size:25px; font-weight:bold;color:black;">{{headerFooters.closingLineAr}}</span>  <span style="margin-left: 10px;color:black;">*</span> <span style="margin-left: 5px;color:black;">*</span> </p>
                        <p v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Gratitude Message (Eng)'))" style="text-align:center;color:black;"> <span style="font-size:25px; font-weight:bold;color:black;">{{headerFooters.closingLineEn}}</span>   </p>
                    </div>
                </div>
            </div>

            <div style="width:400px;border-top:1px solid #000000;border-color:black !important">
                <div style="margin-top:15px;display:flex">
                    <div style="width:400px;display:block;margin-left:20px;margin-top:1.5rem;text-align:center;">
                        <p style="text-align:center;color:black;">  <span style="font-size:18px; font-weight:bold;color:black;">{{getdate(list.date)}}</span></p>

                        <barcode :width="1.9" :height="50" v-bind:value="list.barCode" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Print Barcode'))"></barcode>
                        <vue-qrcode v-bind:value="qrValue" style="width:200px" v-bind:errorCorrectionLevel="correctionLevel" v-if="PrintOption(headerFooters.printOptions.find(x => x.label=='Print QR'))" />
                        <p style="text-align:center;color:black;"><span style="font-size:18px;color:black;">Powered by Tech Qode</span></p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import moment from "moment";
    import VueQrcode from 'vue-qrcode'
    import VueBarcode from 'vue-barcode';



    const options = {
        name: '',
        specs: [
            'fullscreen=no',
            'titlebar=yes',
            'scrollbars=yes'
        ],
        styles: [
            'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
            'https://unpkg.com/kidlat-css/css/kidlat.css'
        ],
        timeout: 700,
        autoClose: true,
        windowTitle: window.document.title
    }
    import clickMixin from '@/Mixins/clickMixin'
    export default {
        mixins: [clickMixin],
        props: ['printDetail', 'headerFooter', 'isTouchScreen', 'isDoublePrint', 'saleId', 'saleReturnRegNo'],
        components: {
            VueQrcode,
            'barcode': VueBarcode,
        },
        data: function () {
            return {
                b2b: false,
                b2c: false,
                taxInvoiceLabel: "",
                taxInvoiceLabelAr: '',
                simplifyTaxInvoiceLabel: '',
                simplifyTaxInvoiceLabelAr: '',
                totalReturnAmount: 0,
                totalInvoiceAmount: 0,
                totalNewInvoiceAmount: 0,
                totalReturnInvoiceAmount: 0,
                totalPaidAmount: 0,
                isCalculationShow: false,
                counterCode: "",
               
                qrValue: "",
                qrValueReturn: "",
                correctionLevel: "H",
                printInterval: '',
                jsonData: '',
                list: {
                    registrationNo: '',
                    date: '',
                    dueDate: '',
                    companyName: '',
                    companyPhoneNo: '',
                    companyAddress: '',
                    discountAmount: '',
                    cashCustomer: '',
                    creditCustomer: '',
                    customerPhoneNo: '',
                    customerAddress: '',
                    paymentMethod: '',
                    paymentMethodNo: '',
                    invocieType: '',
                    saleItems:
                        [

                        ]
                },
                returnList: {
                    registrationNo: '',
                    date: '',
                    dueDate: '',
                    companyName: '',
                    companyPhoneNo: '',
                    companyAddress: '',
                    discountAmount: '',
                    cashCustomer: '',
                    creditCustomer: '',
                    customerPhoneNo: '',
                    customerAddress: '',
                    paymentMethod: '',
                    paymentMethodNo: '',
                    invocieType: '',
                    paymentTypes: [],
                    saleItems:
                        [

                        ],
                    returnList: ''
                },
                render: 0,
                CompanyID: '',
                UserID: '',
                employeeId: '',
                employeeName: '',
                headerFooters: {
                    footerEn: '',
                    footerAr: '',
                    company: ''
                },
                htmlData: {
                    htmlString: ''
                },
                htmlDataReturn: {
                    htmlString: ''
                }
            }
        },
        filters: {
            toWords: function (value) {
                var converter = require('number-to-words');
                if (!value) return ''
                return converter.toWords(value);
            }
        },

        computed: {
            calulateTotalQty: function () {
                return this.list.saleItems.reduce(function (a, c) { return a + (Number((c.quantity) || 0) > 0 ? Number((c.quantity) || 0) : 0) }, 0)
            },
            calulateNetTotal: function () {
                return this.list.saleItems.reduce(function (a, c) { return a + Number((c.total + c.includingVat) || 0) }, 0)
            },
            calulateTotalExclVAT: function () {
                return this.list.saleItems.reduce(function (a, c) { return a + Number((c.total) || 0) }, 0)
            },
            calulateTotalVAT: function () {
                return this.list.saleItems.reduce(function (a, c) { return a + Number((c.includingVat + c.inclusiveVat) || 0) }, 0)
            },
            calulateTotalInclusiveVAT: function () {
                return this.list.saleItems.reduce(function (a, c) { return a + Number((c.inclusiveVat) || 0) }, 0)
            },
            calulateDiscountAmount: function () {
                return this.list.saleItems.reduce(function (a, c) { return a + Number((c.discountAmount) || 0) }, 0)
            },
            calulateBundleAmount: function () {
                return this.list.saleItems.reduce(function (a, c) { return a + Number(c.bundleAmount || 0) }, 0)
            },
            calulateTotalQtyR: function () {
                return this.returnList.saleItems.reduce(function (a, c) { return a + (Number((c.quantity) || 0) > 0 ? Number((c.quantity) || 0) : 0) }, 0)
            },
            calulateNetTotalR: function () {
                return this.returnList.saleItems.reduce(function (a, c) { return a + Number((c.total + c.includingVat) || 0) }, 0)
            },
            calulateTotalExclVATR: function () {
                return this.returnList.saleItems.reduce(function (a, c) { return a + Number((c.total) || 0) }, 0)
            },
            calulateTotalVATR: function () {
                return this.returnList.saleItems.reduce(function (a, c) { return a + Number((c.includingVat + c.inclusiveVat) || 0) }, 0)
            },
            calulateTotalInclusiveVATR: function () {
                return this.returnList.saleItems.reduce(function (a, c) { return a + Number((c.inclusiveVat) || 0) }, 0)
            },
            calulateDiscountAmountR: function () {
                return this.returnList.saleItems.reduce(function (a, c) { return a + Number((c.discountAmount) || 0) }, 0)
            },
            calulateBundleAmountR: function () {
                return this.returnList.saleItems.reduce(function (a, c) { return a + Number(c.bundleAmount || 0) }, 0)
            }
        },
        methods: {
            getdate: function (x) {
                return moment(x).format("lll");
            },
            PrintOption: function (x) {
                if (x == undefined || !x.value) {

                    return false;
                }
                return true;
            },
            calulateDiscountAmount1: function () {
                return this.list.saleItems.reduce(function (a, c) { return a + Number((c.discountAmount) || 0) }, 0)
            },
            calulateBundleAmount1: function () {
                return this.list.saleItems.reduce(function (a, c) { return a + Number(c.bundleAmount || 0) }, 0)
            },
            calulateNetTotalWithVAT: function () {
                var total = this.list.saleItems.reduce(function (a, c) { return a + Number((c.total + c.includingVat) || 0) }, 0);
                var grandTotal = parseFloat(total) - (this.calulateDiscountAmount1() + this.calulateBundleAmount1())
                return (parseFloat(grandTotal).toFixed(3).slice(0, -1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,"));
            },
            calulateTotalVATofInvoice: function () {
                var total = this.list.saleItems.reduce(function (a, c) { return a + Number((c.includingVat + c.inclusiveVat) || 0) }, 0);
                return (parseFloat(total).toFixed(3).slice(0, -1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,"));
            },
            calulateNetTotalWithVATReturn: function () {
                var total = this.returnList.saleItems.reduce(function (a, c) { return a + Number((c.total + c.includingVat) || 0) }, 0);
                return (parseFloat(total).toFixed(3).slice(0, -1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,"));
            },
            calulateTotalVATofInvoiceReturn: function () {
                var total = this.returnList.saleItems.reduce(function (a, c) { return a + Number((c.includingVat + c.inclusiveVat) || 0) }, 0);
                return (parseFloat(total).toFixed(3).slice(0, -1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,"));
            },
            printInvoice: function () {
                var root = this;
                // this.$htmlToPaper('purchaseInvoice');
                this.htmlData.htmlString = this.$refs.mychildcomponent.innerHTML;
                //  var html1 = this.$refs.mychildcomponent.innerHTML;
                //  var data = { html: html1 }
                //
                var printerName = localStorage.getItem('PrinterName')
                var form = new FormData();
                form.append('htmlString', this.htmlData.htmlString);
                form.append('PrintType', 'invoice');
                form.append('PrinterName', printerName);
                //this.$htmlToPaper('purchaseInvoice');
                //axios.post('http://localhos:7013/print/from-pdf', form);
                //axios.post('http://127.0.0.1:7013/print/from-pdf', form);
                //alert();
                //var root = this;
                var isBlindPrint = localStorage.getItem("IsBlindPrint")

                if (isBlindPrint === 'true') {
                    axios.post('http://127.0.0.1:7014/print/from-pdf', form).then(function (x) {
                        console.log(x);

                    });
                    //if (root.isTouchScreen === true) {
                    //    root.$router.go('/TouchInvoice')
                    //}
                }
                else {
                    this.$htmlToPaper('purchaseInvoice', options, () => {
                        if (root.isTouchScreen === true) {
                            root.$router.go('/TouchInvoice')
                        }
                    });

                }


                //var token = '';
                //if (this.$session.exists()) {
                //    token = localStorage.getItem('token');
                //}
                //root.loading = true;
                //root.$https.post('/EmployeeRegistration/PrintPos', data, { headers: { "Authorization": `Bearer ${token}` } }).then(function (x) {
                //    alert(x.data)
                //});



            },
            printReturnInvoice: function () {
                var root = this;

                // this.$htmlToPaper('purchaseInvoice');
                this.htmlDataReturn.htmlString = this.$refs.myReturnComponent.innerHTML;
                //  var html1 = this.$refs.mychildcomponent.innerHTML;
                //  var data = { html: html1 }
                //
                var printerName = localStorage.getItem('PrinterName')
                var form = new FormData();
                form.append('htmlString', this.htmlDataReturn.htmlString);
                form.append('PrintType', 'invoice');
                form.append('PrinterName', printerName);
                //this.$htmlToPaper('purchaseInvoice');
                //axios.post('http://localhos:7013/print/from-pdf', form);
                //axios.post('http://127.0.0.1:7013/print/from-pdf', form);
                //alert();
                //var root = this;
                var isBlindPrint = localStorage.getItem("IsBlindPrint")

                if (isBlindPrint === 'true') {
                    axios.post('http://127.0.0.1:7014/print/from-pdf', form).then(function (x) {
                        console.log(x);
                        if (root.isDoublePrint) {
                            root.printInvoice()


                        }
                    });
                    //if (root.isTouchScreen === true) {
                    //    root.$router.go('/TouchInvoice')
                    //}
                }
                else {
                    this.$htmlToPaper('saleReturn', options, () => {
                        if (root.isDoublePrint) {
                            root.printInvoice()


                        }
                        if (root.isTouchScreen === true) {
                            root.$router.go('/TouchInvoice')
                        }
                    });

                }


                //var token = '';
                //if (this.$session.exists()) {
                //    token = localStorage.getItem('token');
                //}
                //root.loading = true;
                //root.$https.post('/EmployeeRegistration/PrintPos', data, { headers: { "Authorization": `Bearer ${token}` } }).then(function (x) {
                //    alert(x.data)
                //});



            },
            EmployeeData: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/EmployeeRegistration/EmployeeDetail?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {
                            root.employeeName = response.data.englishName;
                        }
                    },
                        function (error) {
                            console.log(error);
                        });
            },
            saleReturnData: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get("/Sale/SaleDetail?id=" + root.saleId, { headers: { Authorization: `Bearer ${token}` }, })
                    .then(function (response) {
                        if (response.data != null) {
                            
                            root.list = response.data;

                            root.list.date = moment().format('DD/MM/YYYY hh:mm:ss A');
                            var sellerNameBuff = root.GetTLVForValue('1', root.headerFooters.company.nameEnglish)
                            var vatRegistrationNoBuff = root.GetTLVForValue('2', root.headerFooters.company.vatRegistrationNo)
                            var timeStampBuff = root.GetTLVForValue('3', root.list.date)
                            var totalWithVat = root.GetTLVForValue('4', root.calulateNetTotalWithVATReturn())
                            var totalVat = root.GetTLVForValue('5', root.calulateTotalVATofInvoiceReturn())
                            var tagArray = [sellerNameBuff, vatRegistrationNoBuff, timeStampBuff, totalWithVat, totalVat]
                            var qrCodeBuff = Buffer.concat(tagArray)
                            root.qrValue = qrCodeBuff.toString('base64')
                            if (root.isDoublePrint) {
                                if (root.list.paymentTypes[root.list.paymentTypes.length - 1].name.includes("SIR")) {
                                    root.totalPaidAmount = root.list.paymentTypes[root.list.paymentTypes.length - 1].amount
                                    root.isCalculationShow = true
                                }
                            }
                            root.PrintData();
                        }
                    });
            },
            PrintData: function () {
                var root = this;
                if (!this.printDetail.registrationNo.includes("SIR")) {
                    if (this.printDetail.saleItems.length > 0) {
                        this.list = this.printDetail;
                        if (root.list.paymentTypes.length > 0) {
                            
                            if (root.list.paymentTypes[root.list.paymentTypes.length - 1].name.includes("SIR")) {
                                root.totalPaidAmount = root.list.paymentTypes[root.list.paymentTypes.length - 1].amount
                                root.isCalculationShow = true
                            }
                        }

                        if (root.$session.exists()) {
                            root.EmployeeData(root.employeeId);
                            var sellerNameBuff = root.GetTLVForValue('1', this.headerFooters.company.nameEnglish)
                            var vatRegistrationNoBuff = root.GetTLVForValue('2', this.headerFooters.company.vatRegistrationNo)
                            var timeStampBuff = root.GetTLVForValue('3', this.list.date)
                            var totalWithVat = root.GetTLVForValue('4', this.calulateNetTotalWithVAT())
                            var totalVat = root.GetTLVForValue('5', this.calulateTotalVATofInvoice())
                            var tagArray = [sellerNameBuff, vatRegistrationNoBuff, timeStampBuff, totalWithVat, totalVat]
                            var qrCodeBuff = Buffer.concat(tagArray)
                            root.qrValue = qrCodeBuff.toString('base64')
                        }
                        setTimeout(function () {
                            root.printInvoice();

                        }, 125)

                    }
                }
                else {
                    if (root.printDetail.saleItems.length > 0) {
                        root.returnList = root.printDetail;
                        if (root.$session.exists()) {
                            root.EmployeeData(root.employeeId);
                            var sellerNameBuffR = root.GetTLVForValue('1', root.headerFooters.company.nameEnglish)
                            var vatRegistrationNoBuffR = root.GetTLVForValue('2', root.headerFooters.company.vatRegistrationNo)
                            var timeStampBuffR = root.GetTLVForValue('3', root.returnList.date)
                            var totalWithVatR = root.GetTLVForValue('4', root.calulateNetTotalWithVATReturn())
                            var totalVatR = root.GetTLVForValue('5', root.calulateTotalVATofInvoiceReturn())
                            var tagArrayR = [sellerNameBuffR, vatRegistrationNoBuffR, timeStampBuffR, totalWithVatR, totalVatR]
                            var qrCodeBuffR = Buffer.concat(tagArrayR)
                            root.qrValueReturn = qrCodeBuffR.toString('base64')
                            setTimeout(function () {
                                root.printReturnInvoice();

                            }, 125)
                        }
                    }
                }
            },
            GetTLVForValue: function (tagNumber, tagValue) {
                var tagBuf = Buffer.from([tagNumber], 'utf-8')
                var tagValueLenBuf = Buffer.from([tagValue.length], 'utf-8')
                var tagValueBuf = Buffer.from(tagValue, 'utf-8')
                var bufsArray = [tagBuf, tagValueLenBuf, tagValueBuf]
                return Buffer.concat(bufsArray)
            }

        },
        mounted: function () {

            var root = this;
            root.b2b = localStorage.getItem('b2b') == 'true' ? true : false;
            root.b2c = localStorage.getItem('b2c') == 'true' ? true : false;
            root.taxInvoiceLabel = localStorage.getItem('taxInvoiceLabel');
            this.taxInvoiceLabelAr = localStorage.getItem('taxInvoiceLabelAr');
            this.simplifyTaxInvoiceLabel = localStorage.getItem('simplifyTaxInvoiceLabel');
            this.simplifyTaxInvoiceLabelAr = localStorage.getItem('simplifyTaxInvoiceLabelAr');
            root.isCalculationShow = false
            root.counterCode = localStorage.getItem('CounterCode');
            root.CompanyID = localStorage.getItem('CompanyID');
            root.UserID = localStorage.getItem('UserID');
            root.employeeId = localStorage.getItem('EmployeeId');
            this.headerFooters = this.headerFooter;

            if (this.isDoublePrint) {
                root.saleReturnData();
            }
            else {
                root.PrintData()
            }
        },

    }
</script>

